import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { FilterInput } from '../../../../common/filterInput'
import LineinputV2 from '../../../../common/lineinputV2'
import { focusElemnt, getFloat } from '../../../../common/helper'
import TablePaginationCustom from '../../../../common/TablePagination'
import { useTranslation } from '../../../../../i18n/I18nProvider'

const CityPairTable = (props) => {
    const {tableData, setTableData, filters, setFilters, editData, setEditData, reportData, handleSearch, totalNoOfRows} = props
    const { translations } = useTranslation()
    const generalSettings = translations?.generalSettings || {}
    const t = (key, fallback) => generalSettings?.[key] || fallback
    // const [rowsPerPage, setRowsPerPage] = useState(10)
    // const [page, setPage] = useState(0)
    const {rowsPerPage, setRowsPerPage,page, setPage} = props
    const [searchData, setSearchData] = useState({
        ServiceTypeID: "",
        ServiceType: "",
        ConsignmentSubTypeID: "",
        SubType: "",
        FromCityName: "",
        ToCityName: "",
        MinFreight: "",
        Rate: "",
        LocalRate: "",
        ETADays: ""
      })

    const matchesContainsFilter = (searchValue, cellValue) => {
        if (!searchValue) return true
        return String(cellValue ?? '').toLowerCase().includes(String(searchValue).toLowerCase())
    }
    const columnTable = [
        { headerName: 'Service Type ID', translationKey: 'serviceTypeId', field: 'ServiceTypeID', headerSx: { width: "120px" }, inputField: false },
        { headerName: 'Service Type', translationKey: 'serviceType', field: 'ServiceType', headerSx: { width: "120px" }, inputField: false },
        { headerName: 'Consignment ID Type', translationKey: 'consignmentIdType', field: 'ConsignmentSubTypeID', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Consignment Type', translationKey: 'consignmentType', field: 'SubType', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Source City Name', translationKey: 'sourceCityName', field: 'FromCityName', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Destination City Name', translationKey: 'destinationCityName', field: 'ToCityName', headerSx: { width: "140px" }, inputField: false },
        { headerName: 'Min Freight', translationKey: 'minFreight', field: 'MinFreight', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'Freight Rate', translationKey: 'freightRate', field: 'Rate', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'Local Freight Rate', translationKey: 'localFreightRate', field: 'LocalRate', headerSx: { width: "140px" }, inputField: true },
        { headerName: 'ETA Days', translationKey: 'etaDays', field: 'ETADays', headerSx: { width: "140px" }, inputField: true },
    ]
    // const handleChange = (e, key, index, row) => {
    //     let newRow = {...row}
    //     newRow[key] = e.target.value
    //     console.log('Hi')
    //     console.log(e, key, index)
    //     let newData = [...tableData]
    //     newData[index][key] = e.target.value
    //     setTableData(newData)
    // }
    const handleChange = (e, key, index, row) => {
        // Update the main tableData
        const updatedRow = { ...row, [key]: e.target.value }
        const newData = [...tableData]
        newData[index] = updatedRow
        setTableData(newData)

        // Update the modifiedRows state
        setEditData(prevModifiedRows => {
            const existingIndex = prevModifiedRows.findIndex(modifiedRow => modifiedRow.ConsignmentSubTypeID === updatedRow.ConsignmentSubTypeID && modifiedRow.FromCityID === updatedRow.FromCityID && modifiedRow.ToCityID === updatedRow.ToCityID)
            if (existingIndex !== -1) {
                // Update existing row in modifiedRows
                const updatedModifiedRows = [...prevModifiedRows]
                updatedModifiedRows[existingIndex] = updatedRow
                return updatedModifiedRows
            } else {
                // Add new modified row to modifiedRows
                return [...prevModifiedRows, updatedRow]
            }
        })
    }
    useEffect(() => {
        const filteredData = reportData?.filter((val) =>
            matchesContainsFilter(searchData?.ServiceTypeID, val?.ServiceTypeID) &&
            matchesContainsFilter(searchData?.ServiceType, val?.ServiceType) &&
            matchesContainsFilter(searchData?.ConsignmentSubTypeID, val?.ConsignmentSubTypeID) &&
            matchesContainsFilter(searchData?.SubType, val?.SubType) &&
            matchesContainsFilter(searchData?.FromCityName, val?.FromCityName) &&
            matchesContainsFilter(searchData?.ToCityName, val?.ToCityName) &&
            matchesContainsFilter(searchData?.MinFreight, val?.MinFreight) &&
            matchesContainsFilter(searchData?.Rate, val?.Rate) &&
            matchesContainsFilter(searchData?.LocalRate, val?.LocalRate) &&
            matchesContainsFilter(searchData?.ETADays, val?.ETADays)
        );
        setTableData(filteredData ?? []);
    }, [searchData, reportData]);

    const handleSearchData = (event, field) => {
        const value = event.target.value.toString();
        setSearchData((prev) => ({ ...prev, [field]: value }));
    }
    return (
        <Box style={{paddingTop:'10px'}}>
            <TableContainer className='scrollBlue' component={Paper} style={{ marginBottom: '5px', maxHeight:'54vh' }}>
                <Table
                    stickyHeader
                    size="small"
                    aria-label="a dense table"
                    sx={{
                        '&.MuiTableCell-root': {
                            padding: '6px 8px!important',
                        },
                    }}
                >
                    <TableHead style={{ position: `sticky`, top: `0`, zIndex: 2 }}>
                        <TableRow>
                            <TableCell colSpan={columnTable?.length} sx={{
                                backgroundColor: '#BFE1FF',
                                fontSize: '12px',
                                fontWeight: '600',
                                color: '#444',
                                height: '40px'
                            }}>
                                {t('consignmentType', 'Consignment Type')}: {filters?.consignmentType?.name}
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            {columnTable?.map((col, index) => (
                                <TableCell key={`CityHeader-${index}`} sx={{
                                    ...col.headerSx,
                                    backgroundColor: '#DAEDFE',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#444',
                                    height: '40px'
                                }}>
                                    {t(col.translationKey, col.headerName)}
                                </TableCell>
                            ))}

                        </TableRow>
                        <TableRow>
                            {columnTable?.map((col, index) => (
                                <TableCell
                                    key={`TH-${index}`}
                                    sx={{
                                        ...col.headerSx,
                                        height: '40px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: '#444',
                                    }}
                                >
                                    <FilterInput label={t('contains', 'Contains')} onChange={(e) => handleSearchData(e, col.field)} />
                                </TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    {tableData?.length > 0 ? <TableBody>
                        { tableData?.map((val, index) => (
                            <TableRow key={`CityPairDataCol-${index}`}>
                                {columnTable.map((col, index1) => (
                                    <>
                                        {!(col?.inputField) ?
                                            <TableCell
                                                key={`CityPairDataCol-${index}-${index1}`}
                                                sx={{
                                                    ...col.headerSx,
                                                    height: '40px',
                                                    fontSize: '12px',
                                                    fontWeight: '500',
                                                    color: '#444',
                                                }}
                                            >
                                                {val?.[col.field]}
                                            </TableCell>
                                            :
                                            <TableCell>
                                                <div className='CityPairRateMatrix'>
                                                    <div className="input--wrapper">
                                                        <LineinputV2
                                                            id={`input-${index}-${index1}`}
                                                            value={val?.[col.field]}
                                                            name="value"
                                                            type="text"
                                                            filter={getFloat}
                                                            onBlur={(e)=>{
                                                                handleChange(e,col.field, index , val)}}
                                                            // onBlur={(event) => {
                                                            //     if (event.key === 'Enter') {
                                                            //         setTimeout(() => {
                                                            //         }, 0)
                                                            //     } else if (event.key === 'Escape') {
                                                            //         setTimeout(() => {
                                                            //         }, 0)
                                                            //     }
                                                            // }}
                                                        />
                                                    </div>
                                                </div>
                                            </TableCell>}
                                    </>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>:
                <TableBody>
                  <TableRow>
                    <TableCell colSpan={columnTable?.length}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          marginTop: '20px',
                          marginBottom: '20px',
                          color: 'red',
                          fontSize: '14px',
                        }}
                      >
                        <span>{t('noResultsSelectedFiltersTitle', 'No Results Found For The Selected Filters.')}</span>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>}
                </Table>
            </TableContainer>
            <TablePaginationCustom totRowCount={totalNoOfRows} rowsPerPageOptions={[10, 20, 50, 100, 200, 500]} rowsPerPage={rowsPerPage} page={page} handleChangePage={(event, newPage) => {
                setPage(newPage);handleSearch(newPage,rowsPerPage)
            }} handleChangeRowsPerPage={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
                handleSearch(0,parseInt(event.target.value, 10))
            }} />
        </Box>
    )
}

export default CityPairTable
